import { SURETY_PLAN_NAME, WORK_ADVISORY_PLAN_NAME } from "./domain-constants";
import type { MySubscription } from "@/types/domain";

/**
 * A dónde entra el usuario al abrir la app. Lo decide el plan: una constructora
 * no busca licitaciones en el radar, abre directo su análisis de obras.
 */
export function getLandingRoute(
  subscription?: MySubscription | null,
): string {
  if (subscription?.planKey === WORK_ADVISORY_PLAN_NAME)
    return "/work-advisory";
  if (subscription?.planKey === SURETY_PLAN_NAME) return "/surety";
  return "/dashboard";
}
